import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M7.99333 12.3602L3.08 8.54016L2 9.38016L8 14.0468L14 9.38016L12.9133 8.5335L7.99333 12.3602ZM8 10.6668L12.9067 6.84683L14 6.00016L8 1.3335L2 6.00016L3.08667 6.84683L8 10.6668ZM8 3.02016L11.8267 6.00016L8 8.98016L4.17333 6.00016L8 3.02016V3.02016Z" fill="black"/>
</svg>
;
